import { Show, ShowFirstMatching } from '@components/Show';

export interface MultiSelectDetailsPanelProps {
  label: string;
  items: Array<{ id: string | number; name: string }>;
  isLoading?: boolean;
  onItemClick?: (id: string | number) => void;
  showIcon?: boolean;
}

export function MultiSelectDetailsPanel({
  label,
  items,
  isLoading = false,
  onItemClick,
  showIcon = false,
}: MultiSelectDetailsPanelProps) {
  return (
    <div className="bg-gray-50">
      <div className="flex flex-col gap-4 px-[14px] pt-[14px] pb-6">
        <div className="flex items-center justify-between">
          <p className="text-base leading-6 font-medium text-gray-900">{label}</p>
        </div>
        <div className="h-px w-full bg-gray-300" />
        <div className="flex max-h-96 flex-col gap-3 overflow-y-auto">
          <ShowFirstMatching>
            <Show when={isLoading}>
              {Array.from({ length: items.length || 3 }).map((_, index) => (
                <div key={`skeleton-${index}`}>
                  <div className="h-4 w-3/4 animate-pulse rounded-md bg-gray-200" />
                </div>
              ))}
            </Show>
            <Show when={!isLoading}>
              {items.map(({ id, name }) => (
                <div key={id} className="group">
                  {onItemClick ? (
                    <span
                      className="text-primary-500 group-hover:text-primary-600 flex cursor-pointer justify-between gap-1 text-sm leading-4 font-medium"
                      onClick={() => onItemClick(id)}
                    >
                      <span className="overflow-hidden text-ellipsis whitespace-nowrap no-underline hover:underline">
                        {name}
                      </span>
                      {showIcon && <span className="opacity-75 group-hover:opacity-100">→</span>}
                    </span>
                  ) : (
                    <span className="flex gap-1 text-sm leading-4 font-medium text-gray-700">
                      <span className="overflow-hidden text-ellipsis whitespace-nowrap">{name}</span>
                    </span>
                  )}
                </div>
              ))}
            </Show>
          </ShowFirstMatching>
        </div>
      </div>
    </div>
  );
}
